module.exports = __webpack_public_path__ + "static/2-d766a7e278221b81fc7e511c2b293467.jpg";